import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SessionAddSuccessLabelConstant } from 'src/app/constants/LabelConstants';

@Component({
    selector: 'app-session-add-success-dialog',
    templateUrl: './session-add-success-dialog.component.html',
    styleUrls: ['./session-add-success-dialog.component.scss'],
    standalone: false
})
export class SessionAddSuccessDialogComponent implements OnInit {

  customerData: any;
  LabelConstant: any;

  constructor(
    private dialogRef: MatDialogRef<SessionAddSuccessDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    this.LabelConstant = SessionAddSuccessLabelConstant;
  }

  handleImageError() {
    this.customerData.images = '../../../../assets/img/default-customer-profile.svg';
  }
}